<template>
  <div>
    <router-link :to="{ name: 'show_message', params: { id: message.itemid} }" class="feed-tile">
      <h5 v-if="message.all_students" class="tile-addressee">An: Alle Schüler</h5>
      <h5 v-else-if="message.selected_receivers" class="tile-addressee">
        An:
        <span v-for="(receiver, index) in message.selected_receivers">
          <span v-if="index < 2">{{ receiver.title }}</span><span v-if="index < 1 && index !== (message.selected_receivers.length - 1)">, </span><span v-if="index === 2">...</span>
        </span>
        <span v-if="!message.selected_receivers[0]">No receivers selected</span>
      </h5>
      <h5 v-else class="tile-addressee">Von: {{ message.sender.title }}</h5>
      <h3 class="tile-title">
        <twemoji :content="message.title"/>
      </h3>
      <h5 class="tile-date">{{ message.date | formatDate }}</h5>

      <p v-if="message.confirmation && message.selected_receivers" class="tile-read-info">{{ message.confirmed }} von {{ message.selected_receivers.length }} haben bestätigt</p>
      <p v-else-if="message.pool && message.selected_receivers" class="tile-read-info">{{ message.confirmed }} von {{ message.selected_receivers.length }} haben abgestimmt</p>
      <p v-else-if="message.sick" class="tile-read-info">
        Wird noch {{ message.nr_days_shown }}
        <span v-if="message.nr_days_shown > 1">Tage</span>
        <span v-else>Tag</span>
        angezeigt
      </p>

      <div v-if="user.parent">
        <div v-if="message.pool">
          <p v-if="!message.confirmed && !message.closed" class="tile-read-info tile-alert">Abstimmung offen</p>
          <p v-else-if="message.confirmed_by && message.confirmed_by.itemid === user.item_id" class="tile-read-info">Abgestimmt von mir</p>
          <p v-else-if="message.confirmed_by" class="tile-read-info">Abgestimmt von {{ message.confirmed_by.title }}</p>
        </div>
        <div v-else-if="message.confirmation">
          <p v-if="!message.confirmed && !message.closed" class="tile-read-info tile-alert">Bestätigung offen</p>
          <p v-else-if="message.confirmed_by && message.confirmed_by.itemid === user.item_id" class="tile-read-info">Bestätigt von mir</p>
          <p v-else-if="message.confirmed_by" class="tile-read-info">Bestätigt von {{ message.confirmed_by.title }}</p>
        </div>
        <div v-else-if="message.confirmed_by">
          <p v-if="message.confirmed_by.title === user.name" class="tile-read-info">Beantwortet von mir</p>
          <p v-else class="tile-read-info">Beantwortet von {{ message.confirmed_by.title }}</p>
        </div>
      </div>

      <div v-if="message.unread" class="tile-active-dot"></div>

      <div class="tile-type-icon">
        <img v-if="message.link" :src="'./static/img/' + user.role +'/attachment.png'" style="height: 26px;">
        <img v-if="message.confirmation" class="icon-confirmation" :src="'./static/img/' + user.role +'/nachricht.png'">
        <img v-else-if="message.pool" class="icon-poll" :src="'./static/img/' + user.role +'/message_poll.png'">
        <img v-else-if="message.sick" class="icon-poll" :src="'./static/img/' + user.role +'/krankmeldung_hdpi.png'">
        <img v-else class="icon-message" :src="'./static/img/' + user.role +'/message_text.png'">
      </div>

    </router-link>
  </div>
</template>

<script>
export default {
  props: ['message'],
  data() {
    return {
      user: this.$current_user,
    };
  },
  methods: {
    updateReadStatus (id, message) {
      if(id === this.message.itemid) {

        // this.message = message;
        if(message.confirmed) {
          this.message.confirmed = '';
          this.message.confirmed = message.confirmed;
        }
        this.message.confirmation = message.confirmation;
        this.message.closed = '';

        this.message.closed = message.closed;
        this.message.unread = message.status;

        if(message.confirmed_by) {
          this.message.confirmed_by = message.confirmed_by;
        }
      }
    }
  },
  mounted() {
    this.$bus.$on('message:refresh', this.updateReadStatus);
  },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Messages/Feed/Tile.vue